var content = require("!!../../../../../../../../../../node_modules/css-loader/dist/cjs.js!../../../../../../../../../../node_modules/postcss-loader/src/index.js!../../../../../../../../../../node_modules/sass-loader/dist/cjs.js??ref--7-3!./mobile-offer-details.scss");

if (typeof content === 'string') {
  content = [[module.id, content, '']];
}

var options = {}

options.insert = "head";
options.singleton = false;

var update = require("!../../../../../../../../../../node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js")(content, options);

if (content.locals) {
  module.exports = content.locals;
}

if (module.hot) {
  if (!content.locals) {
    module.hot.accept(
      "!!../../../../../../../../../../node_modules/css-loader/dist/cjs.js!../../../../../../../../../../node_modules/postcss-loader/src/index.js!../../../../../../../../../../node_modules/sass-loader/dist/cjs.js??ref--7-3!./mobile-offer-details.scss",
      function () {
        var newContent = require("!!../../../../../../../../../../node_modules/css-loader/dist/cjs.js!../../../../../../../../../../node_modules/postcss-loader/src/index.js!../../../../../../../../../../node_modules/sass-loader/dist/cjs.js??ref--7-3!./mobile-offer-details.scss");

        if (typeof newContent === 'string') {
          newContent = [[module.id, newContent, '']];
        }
        
        update(newContent);
      }
    )
  }

  module.hot.dispose(function() { 
    update();
  });
}